import React, { createContext, useContext } from 'react';

interface ITextInputProps {
  id: string;
  children: React.ReactNode;
  isValid?: boolean;
  isInvalid?: boolean;
  UNSAFE_className?: string;
  isRequired?: boolean;
}

type TTextInputContext = Omit<ITextInputProps, 'children'>;

const TextInputContext = createContext<TTextInputContext>({
  id: '',
  isValid: false,
  isInvalid: false,
  isRequired: false,
  UNSAFE_className: '',
});

export const useTextInput = () =>
  useContext<TTextInputContext>(TextInputContext);

const TextInput: React.FC<ITextInputProps> = ({
  id,
  children,
  isValid,
  isInvalid,
  UNSAFE_className = '',
  isRequired = false,
}) => {
  return (
    <TextInputContext.Provider value={{ id, isValid, isInvalid, isRequired }}>
      <div
        className={`${UNSAFE_className} tw-relative [&:has(input:disabled)]:tw-lf-input-disabled`}
      >
        {children}
      </div>
    </TextInputContext.Provider>
  );
};

export default TextInput;
